import React from 'react';

import styles from './InputBlock.module.scss';

interface InputBlockProps {
  inputPlaceholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const InputBlock = ({ inputPlaceholder, value, onChange }: InputBlockProps) => {
  if (!inputPlaceholder && !value) return null;
  return (
    <div className={styles.container}>
      <textarea
        className={styles.textArea}
        rows={1}
        value={value}
        onChange={onChange}
        placeholder={value || inputPlaceholder}></textarea>
    </div>
  );
};
